var render = function () {
  var _vm$configuration$app;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoading,
      expression: "!isLoading"
    }],
    staticClass: "splash-page splash-page--desktop splash-page--desktop-ge",
    on: {
      "click": _vm.backgroundClick
    }
  }, [_c('div', {
    staticClass: "splash-page-modal-top-nav-close splash-page__nav-close",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closeClick.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })]), _c('div', {
    ref: "partsCustomize",
    class: ['splash-page-modal-graphic-editor-img', !_vm.isUgcApplied ? 'splash-page-modal-graphic-editor-not-ugc' : '']
  }, [_c('div', {
    staticClass: "skip-cta splash-page__skip"
  }, [_c('button', {
    staticClass: "splash-page__label",
    on: {
      "click": _vm.onSkip
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('skipToGetStarted')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('header') && _vm.isUgcApplied,
      expression: "verifyModuleVisibility('header') && isUgcApplied"
    }],
    class: ['splash-page__ge-zoom', 'splash-page__header-tools', _vm.regionIsApac ? 'splash-page__header-tools--apac' : '']
  }, [_c('img', {
    staticClass: "splash-page__arrow splash-page__arrow--tools",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-scroll.svg")
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('header'),
      expression: "verifyModuleVisibility('header')"
    }],
    class: ['splash-page__ge-customize', 'splash-page__header-tools', _vm.regionIsApac ? 'splash-page__header-tools--apac' : '']
  }, [_c('img', {
    staticClass: "splash-page__arrow splash-page__arrow--tools",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-hand-touch.svg")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('tapGraphicCustomize')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('tabs') && _vm.isUgcApplied,
      expression: "verifyModuleVisibility('tabs') && isUgcApplied"
    }],
    staticClass: "splash-page__ge-drag-rep-img"
  }, [_c('img', {
    staticClass: "splash-page-desktop__arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-hand-direction.svg")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('dragRepositionImage')))])]), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('manual_zoom') && ((_vm$configuration$app = _vm.configuration.apparel_settings) === null || _vm$configuration$app === void 0 ? void 0 : _vm$configuration$app.enable_graphic_zoom) && _vm.isUgcApplied,
      expression: "verifyModuleVisibility('manual_zoom') && configuration.apparel_settings?.enable_graphic_zoom && isUgcApplied"
    }],
    staticClass: "splash-page__ge-manual-zoom-control"
  }, [_c('img', {
    staticClass: "splash-page-desktop__arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/bottom-to-up-circle-arrow.svg")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('manualZoomControl')))]), _vm._m(0), _c('img', {
    staticClass: "splash-page__ge-manual-zoom-control right-to-left-circle-arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/right-to-left-circle-arrow.svg")
    }
  })])]), _c('div', {
    staticClass: "splash-page__ge-done"
  }, [_c('label', {
    staticClass: "splash-page_ge-done-button"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.apparel.graphicZoomOut) + "\n    ")]), _c('img', {
    staticClass: "splash-page-desktop__arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/add-your-own-arrow-step2.png")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('tapDone')))])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "splash-page_ge-manual-zoom-control tool"
  }, [_c('label', {
    staticClass: "control-left"
  }, [_vm._v("-")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    staticClass: "custom-input",
    attrs: {
      "disabled": "",
      "value": "2",
      "min": "1",
      "max": "5",
      "type": "range"
    }
  })]), _c('label', {
    staticClass: "control-right"
  }, [_vm._v("+")])]);
}]

export { render, staticRenderFns }